<template>
    <div>
        <van-nav-bar
                title="库存查询"
                left-text=""
                right-text="筛选"
                left-arrow
                fixed
                @click-left="back()"
                @click-right="searchPop()"
                v-if="show"
        />


        <!--<van-tabs v-model="active" color='#6685a4' title-active-color="#6685a4">
          <van-tab title="包装明细" name="package">
            <div>
              <van-pull-refresh v-model="isLoadingPac" @refresh="onRefresh">
                <van-list
                    v-model="loadingPac"
                    :finished="finishedPac"
                    finished-text="没有更多了"
                    @load="onLoad"
                >
                  <van-cell v-for="item in listPac" :key="item.id" class="swipewarp">
                    <van-row gutter="20">
                      <van-col span="8" style="">
                        包装号
                      </van-col>
                      <van-col span="16" style="text-align: right;word-break:keep-all;white-space:nowrap;">
                        {{ item.packageNo }}
                      </van-col>
                    </van-row>
                    <van-row gutter="20" style="color: #727272">
                      <van-col span="8" style="">
                        件数/净重
                      </van-col>
                      <van-col span="16" style="text-align: right;word-break:keep-all;white-space:nowrap;">
                        {{ item.amount }}件/{{ item.weight }}公斤
                      </van-col>
                    </van-row>
                    <van-row gutter="20" style="color: #727272">
                      <van-col span="8" style="word-break:keep-all;white-space:nowrap;">
                        货位
                      </van-col>
                      <van-col span="16" style="text-align: right;word-break:keep-all;white-space:nowrap;">
                        {{ getPosition(item.wcode, item.acode, item.pcode) }}
                      </van-col>
                    </van-row>
                  </van-cell>
                </van-list>
              </van-pull-refresh>
            </div>
          </van-tab>
          <van-tab title="物料明细" name="product">-->
        <div class="contentwarp">
            <van-pull-refresh v-model="isLoadingPro" @refresh="onRefresh">
                <van-list style="padding-bottom: 100px"
                        v-model="loadingPro"
                        :finished="finishedPro"
                        finished-text="没有更多了"
                        @load="onLoad"
                >

                    <van-cell v-for="item in listPro" :key="item.id" style="padding: 0">
                        <van-row gutter="20" v-if="item.isShowMerge" style="background: #fee7c5;padding: 5px 15px;">
                            <van-col span="18" class="ellipsis">
                                包装号:{{ item.packageNo }}
                            </van-col>
                            <van-col span="6" class="ellipsisRight">
                                {{ item.packageName }}
                            </van-col>

                        </van-row>
                        <van-row gutter="20" style="padding-top: 5px">
                            <van-col span="8" class="ellipsis">
                                物料号/钢卷号
                            </van-col>
                            <van-col span="16" class="ellipsisRight">
                                {{ item.cargoNumber }}/{{ item.tscNumber }}
                            </van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="3" class="ellipsis">
                                品名
                            </van-col>
                            <van-col span="21" class="ellipsisRight">
                                {{ item.cargoName }}/ {{ item.cargoMaterialName }}/
                                {{
                                item.cargoThickness == null ? '' : item.cargoThickness
                                }}x{{ item.cargoWidth == null ? '' : item.cargoWidth }}x{{ item.cargoLength |
                                getCargoLength }}/
                                {{ item.cargoOriginName }}/ {{ item.surfaceName }}
                            </van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="10" class="ellipsis">
                                件数/重量
                            </van-col>
                            <van-col span="14" class="ellipsisRight">
                                {{ item.amount }}件/{{ item.weight }}公斤
                            </van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="4" class="ellipsis">
                                货位
                            </van-col>
                            <van-col span="20" class="ellipsisRight">
                                {{ getPosition(item.wcode, item.acode, item.pcode) }}
                            </van-col>
                        </van-row>
                        <van-row gutter="20" style="padding-bottom: 8px" v-if="!item.isShowView">
                            <van-col span="4" class="ellipsis">
                                备注
                            </van-col>
                            <van-col span="20" class="ellipsisRight">
                                {{ item.remarks }}
                            </van-col>
                        </van-row>
                        <van-row gutter="20" style="padding-bottom: 8px" v-if="item.isShowView">
                            <van-col span="4" class="ellipsis">
                                备注
                            </van-col>
                            <van-col span="20" class="ellipsisRight">
                                {{ item.remarks }}
                            </van-col>
                        </van-row>
                    </van-cell>

                </van-list>
            </van-pull-refresh>
        </div>
        <div class="hejcss">
            合计：{{ pacCount }}包，{{ proCount }}件，{{ parseFloat(parseFloat(pacWeight) + parseFloat(proWeight)).toFixed(3)
            }}吨
        </div>
        <!--      </van-tab>
            </van-tabs>-->

        <van-popup v-model="searchShowPop" position="right" :style="{ height: '100%', width:'90%'}">
            <van-nav-bar
                    title="筛选"
                    fixed
                    z-index="9000"
                    left-arrow
                    @click-left="() => this.searchShowPop = false"
            />
            <div class="searchwarp">
                <van-field v-model="searchValue.key" label="关键字" placeholder="钢卷号/物料号/包装号" autocomplete="off"
                           label-width="80px" label-align="right"/>
                <!--        <van-field :value="selWcode" readonly name="picker" label="仓库" placeholder="点击选择仓库" @click="showPickerCK = true"
                                   label-width="80px" label-align="right"/>-->
                <van-field :value="selFreeze" readonly name="picker" label="库存状态" placeholder="点击选择状态"
                           @click="showPicker('showPickerSta')"
                           label-width="80px" label-align="right"/>
                <van-field :value="selPcmode" readonly name="picker" label="属性" placeholder="点击选择属性"
                           @click="showPicker('showPickerMode')"
                           label-width="80px" label-align="right"/>
                <van-field :value="selCargoProcessName" readonly name="picker" label="品名" placeholder="点击选择品名"
                           @click="showPicker('showPickerCar')" label-width="80px" label-align="right"/>
                <van-field v-model="searchValue.modelH" label="规格厚" placeholder="请输入规格厚" autocomplete="off"
                           label-width="80px" label-align="right"/>
                <van-field v-model="searchValue.modelK" label="规格宽" placeholder="请输入规格厚" autocomplete="off"
                           label-width="80px" label-align="right"/>
                <van-field v-model="searchValue.modelC" label="规格长" placeholder="请输入规格厚" autocomplete="off"
                           label-width="80px" label-align="right"/>
                <van-field :value="selCargoMaterialName" readonly name="picker" label="材质" placeholder="点击选择材质"
                           @click="showPicker('showPickerMat')" label-width="80px" label-align="right"/>
                <van-field :value="cargoOriginName" readonly name="picker" label="品牌" placeholder="点击选择品牌"
                           @click="showPicker('showPickerOri')" label-width="80px" label-align="right"/>
                <van-field :value="surfaceName" readonly name="picker" label="表面" placeholder="点击选择表面"
                           @click="showPicker('showPickerSur')" label-width="80px" label-align="right"/>
                <!--        <van-field v-model="searchValue.from" label="入库日期" readonly="readonly" placeholder="点击选择日期" autocomplete="off"
                           @click="calendarShow=true" label-width="80px" label-align="right"/>-->
                <!--        <van-picker
                            title="仓库"
                            v-if="showPickerCK"
                            show-toolbar
                            :columns="cargocolCK"
                            @confirm="selWcodeVal"
                            @cancel="showPickerCK = false"
                        />-->
                <van-picker
                        title="库存状态"
                        v-if="showPickerSta"
                        show-toolbar
                        :columns="freezeCol"
                        @confirm="selFreezeVal"
                        @cancel="showPickerSta = false"
                />
                <van-picker
                        title="属性"
                        v-if="showPickerMode"
                        show-toolbar
                        :columns="pcmodeCol"
                        @confirm="selPcmodeVal"
                        @cancel="showPickerMode = false"
                />
                <van-picker
                        title="品名"
                        v-if="showPickerCar"
                        show-toolbar
                        :columns="cargoNamecol"
                        @confirm="selCargoProcessVal"
                        @cancel="showPickerCar = false"
                />
                <van-picker
                        title="材质"
                        v-if="showPickerMat"
                        show-toolbar
                        :columns="cargoMaterialcol"
                        @confirm="selCargoMaterialVal"
                        @cancel="showPickerMat = false"
                />
                <van-picker
                        title="品牌"
                        v-if="showPickerOri"
                        show-toolbar
                        :columns="cargoOrigincol"
                        @confirm="selCargoOriginVal"
                        @cancel="showPickerOri = false"
                />
                <van-picker
                        title="表面"
                        v-if="showPickerSur"
                        show-toolbar
                        :columns="surfaceCol"
                        @confirm="selSurfaceVal"
                        @cancel="showPickerSur = false"
                />
                <!--        <van-calendar v-model="calendarShow"
                              :min-date=" new Date(2020, 9, 1)"
                              :default-date="[new Date((new Date()-30000*60*60*24)),new Date() ]"
                              type="range" @confirm="calendarConfirm"/>-->
                <van-row gutter="20" style="margin-top:20px">
                    <van-col span="8" offset="4">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="resetSearch()">
                            重置
                        </van-button>
                    </van-col>
                    <van-col span="8">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="onSearch()">
                            确定
                        </van-button>
                    </van-col>
                </van-row>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {
        Button,
        Calendar,
        Cell,
        Col,
        Divider,
        Field,
        Form,
        Grid,
        GridItem,
        Icon,
        Image as VanImage,
        ImagePreview,
        Lazyload,
        List,
        NavBar,
        Picker,
        Popup,
        PullRefresh,
        Radio,
        RadioGroup,
        Row,
        Search,
        Sticky,
        SwipeCell,
        Toast,
        Tab,
        Tabs,
    } from 'vant';
    import service from '../../server/index'

    Vue.use(Lazyload, {
        lazyComponent: true,
    });
    Vue.use(Tab);
    Vue.use(Tabs);

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Divider.name]: Divider,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Form.name]: Form,
            [Picker.name]: Picker
        },
        computed: {
            showStatus() {
                return function (item) {
                    if (item.status == 30) {
                        return "done";
                    } else {
                        if (item.balanceStatus == 0) {
                            return "unpay";
                        } else {
                            return "pay"
                        }
                    }
                }
            },
            showDetailStatus() {
                return function (item) {
                    if (item.status == 30) {
                        return "done";
                    } else if (item.status == 20) {
                        return "verify"
                    }
                }
            },
            showMoney() {
                return function (cash) {
                    return Math.round((cash + Number.EPSILON) * 100) / 100;
                }
                // cash.toFixed(2);
                // return Math.round((cash + Number.EPSILON) * 100) / 100;
                // return cash.toFixed(2);
            }
        },
        data() {
            return {
                active: 'package',
                value: "",
                show: true,//nav bar
                showtitle: false,
                ershow: false,
                qrcodeContent: "",
                title: "",
                listPac: [],
                listPro: [],
                loadingPac: true,
                loadingPro: true,
                finishedPac: false,
                finishedPro: false,
                searchValue: {
                    modelHType: 10,
                    modelKType: 10,
                    modelCType: 10,
                    modelH: "",
                    modelC: "",
                    modelK: "",
                    key: "",
                },
                selCargoProcessName: "",
                selCargoMaterialName: "",
                cargoOriginName: "",
                surfaceName: "",
                showPickerCar: false,
                showPickerMat: false,
                showPickerOri: false,
                showPickerSur: false,
                showPickerCK: false,
                showPickerSta: false,
                showPickerMode: false,
                selWcode: "",
                selFreeze: "",
                selPcmode: "",
                wodeData: [],
                cargoProcessData: [],
                cargoMaterialData: [],
                cargoOriginData: [],
                surfaceData: [],
                freezeData: [{value: undefined},
                    {value: '0'},
                    {value: '30'},
                    {value: '40'},],
                freezeCol: ['全部库存', '可用库存', '待加工', '待提货'],
                cargocolCK: [],
                cargoNamecol: [],
                cargoMaterialcol: [],
                cargoOrigincol: [],
                surfaceCol: [],
                pcmodeData: [{value: undefined},
                    {value: '10'},
                    {value: '20'},
                    {value: '30'},
                    {value: '40'},
                    {value: '50'},
                ],
                pcmodeCol: ['全部', '原料', '余料', '成品', '废料', '尾板'],
                searchShowPop: false,
                dateFormat: 'YYYY-MM-DD',
                //刷新
                isLoadingPac: false,
                isLoadingPro: false,
                pagePac: 1,
                pagePro: 1,
                pageSize: 20,
                //日期选择calendarShow
                calendarShow: false,
                pacCount: 0,
                pacWeight: 0,
                proCount: 0,
                proWeight: 0,
                mergeList: [],
            }
        },
        mounted() {
            this.onSearch();
            let parm = {};
            parm.ouid = localStorage.getItem("ouid")
            /*    service.selWarehouseG(parm).then(res => {
                  let data = res.data;
                  this.wodeData = data;
                  for (let i = 0; i < data.length; i++) {
                    this.cargocolCK.push(data[i].wcode)
                  }
                })*/
            service.selCargoProcessP(parm).then(res => {
                let data = res.data;
                this.cargoProcessData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.cargoNamecol.push(data[i].cargoProcessName)
                }
            })
            service.selCargoMaterialProcessG(parm).then(res => {
                let data = res.data;
                this.cargoMaterialData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.cargoMaterialcol.push(data[i].cargoMaterialName)
                }
            })
            service.selCargoOriginProcessG(parm).then(res => {
                let data = res.data;
                this.cargoOriginData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.cargoOrigincol.push(data[i].cargoOriginName)
                }
            })
            service.selSurfaceNameG(parm).then(res => {
                let data = res.data;
                this.surfaceData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.surfaceCol.push(data[i].surfaceName)
                }
            })
        },
        filters: {
            getCargoLength(cargoLength) {
                if (cargoLength == null) {
                    return 'C';
                } else {
                    if (cargoLength == 0) {
                        return 'C';
                    } else {
                        if (cargoLength > 10000) {
                            return cargoLength / 1000 + 'm'
                        } else {
                            return cargoLength
                        }
                    }
                }
            }
        },
        methods: {
            showPicker(pickerName) {
                this.showPickerSta = false
                this.showPickerMode = false
                this.showPickerCar = false
                this.showPickerMat = false
                this.showPickerOri = false
                this.showPickerSur = false

                switch (pickerName) {
                    case 'showPickerSta':
                        this.showPickerSta = true
                        break
                    case 'showPickerMode':
                        this.showPickerMode = true
                        break
                    case 'showPickerCar':
                        this.showPickerCar = true
                        break
                    case 'showPickerMat':
                        this.showPickerMat = true
                        break
                    case 'showPickerOri':
                        this.showPickerOri = true
                        break
                    case 'showPickerSur':
                        this.showPickerSur = true
                        break
                    default:
                        return false
                }
            },
            getPosition(wcode, acode, pcode) {
                if (wcode == '' && acode == '' && pcode == '') {
                    return '请选择';
                } else if (wcode != '' && acode == '' && pcode == '') {
                    return wcode;
                } else if (wcode != '' && acode != '' && pcode == '') {
                    return wcode + "/" + acode;
                } else if (wcode != null && acode != null && pcode != null) {
                    return wcode + "/" + acode + "/" + pcode;
                } else if (wcode != null && acode != null) {
                    return wcode + "/" + acode;
                } else if (wcode != null) {
                    return wcode;
                }
            },
            back() {
                this.$router.replace("/Home/Search")
            },
            selCargoProcessVal(value, index) {
                this.selCargoProcessName = value;
                this.searchValue.cargoId = this.cargoProcessData[index].cargoProcessId
                this.showPickerCar = false;
            },
            selCargoMaterialVal(value, index) {
                this.selCargoMaterialName = value;
                this.searchValue.cargoMaterialId = this.cargoMaterialData[index].cargoMaterialId
                this.showPickerMat = false;
            },
            selCargoOriginVal(value, index) {
                this.cargoOriginName = value;
                this.searchValue.cargoOriginId = this.cargoOriginData[index].cargoOriginId
                this.showPickerOri = false;
            },
            selSurfaceVal(value, index) {
                this.surfaceName = value;
                this.searchValue.surfaceId = this.surfaceData[index].surfaceId
                this.showPickerSur = false;
            },
            /*  selWcodeVal(value, index) {
                this.selWcode = value;
                this.searchValue.warehouseId = this.wodeData[index].warehouseId
                this.showPickerCK = false;
              },*/
            selFreezeVal(value, index) {
                this.selFreeze = value;
                this.searchValue.freezeType = this.freezeData[index].value
                this.showPickerSta = false;
            },
            selPcmodeVal(value, index) {
                this.selPcmode = value;
                this.searchValue.pcmode = this.pcmodeData[index].value
                this.showPickerMode = false;
            },
            onSearch() {
                this.listPac = [];
                this.listPro = [];
                this.pagePac = 1;
                this.pagePro = 1;
                this.showtitle = false;
                this.show = true;
                this.searchShowPop = false;
                this.onLoad();
            },
            onLoad() {
                /* this.selPackageCurStock();
                 this.selProductCurStock();*/
                this.selJgCurStock();
                this.selCountAndWeight();
            },
            selJgCurStock() {
                let param = this.searchValue;
                if (param.modelH != "") {
                    let index = param.modelH.indexOf("-");
                    if (index >= 0) {
                        param.modelHType = 20;
                        let spList = param.modelH.split("-");
                        param.modelHStrat = spList[0];
                        param.modelHEnd = spList[1];
                    } else {
                        param.modelHType = 10;
                    }
                }

                if (param.modelK != "") {
                    let index = param.modelK.indexOf("-");
                    if (index >= 0) {
                        param.modelKType = 20;
                        let spList = param.modelK.split("-");
                        param.modelKStrat = spList[0];
                        param.modelKEnd = spList[1];
                    } else {
                        param.modelKType = 10;
                    }
                }

                if (param.modelC != "") {
                    let index = param.modelC.indexOf("-");
                    if (index >= 0) {
                        param.modelCType = 20;
                        let spList = param.modelC.split("-");
                        param.modelCStrat = spList[0];
                        param.modelCEnd = spList[1];
                    } else {
                        param.modelCType = 10;
                    }
                }

                param.ouid = localStorage.getItem("ouid");
                param.customerId = localStorage.getItem("customerId");
                param.limit = this.pageSize;
                param.pagePro = this.pagePro;
                service.selJgCurStock(param).then((res) => {
                    if (res.code == "200") {
                        if (res.data != null && res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.listPro.push(res.data[i]);
                            }

                            let dataList = this.listPro
                            let mergeList = [];
                            for (let i = 0; i < dataList.length; i++) {
                                if (dataList[i].processtaskPackageId) {
                                    if (mergeList.indexOf(dataList[i].processtaskPackageId) == -1) {
                                        mergeList.push(dataList[i].processtaskPackageId)
                                        dataList[i].isShowMerge = true;

                                        this.mergeList = mergeList
                                    } else {
                                        dataList[i].isShowMerge = false;
                                    }
                                } else {
                                    dataList[i].isShowMerge = false;
                                }

                                if (dataList[i].processtaskPackageId == null) {
                                    dataList[i].isShowView = true;
                                } else {
                                    if (dataList[i + 1] != null) {
                                        if (dataList[i + 1].processtaskPackageId != dataList[i].processtaskPackageId) {
                                            dataList[i].isShowView = true;
                                        } else {
                                            dataList[i].isShowView = false;
                                        }
                                    } else {
                                        dataList[i].isShowView = true;
                                    }
                                }
                            }
                            this.pagePro++
                        } else {
                            this.finishedPro = true;
                        }
                        // 加载状态结束
                        this.loadingPro = false;
                        this.isLoadingPro = false;
                    } else {
                        this.loadingPro = false;
                        this.finishedPro = true;
                        this.isLoadingPro = false;
                        Toast(res.msg)
                    }
                });
            },
            selCountAndWeight() {
                let param = this.searchValue;
                if (param.modelH != "") {
                    let index = param.modelH.indexOf("-");
                    if (index >= 0) {
                        param.modelHType = 20;
                        let spList = param.modelH.split("-");
                        param.modelHStrat = spList[0];
                        param.modelHEnd = spList[1];
                    } else {
                        param.modelHType = 10;
                    }
                }

                if (param.modelK != "") {
                    let index = param.modelK.indexOf("-");
                    if (index >= 0) {
                        param.modelKType = 20;
                        let spList = param.modelK.split("-");
                        param.modelKStrat = spList[0];
                        param.modelKEnd = spList[1];
                    } else {
                        param.modelKType = 10;
                    }
                }

                if (param.modelC != "") {
                    let index = param.modelC.indexOf("-");
                    if (index >= 0) {
                        param.modelCType = 20;
                        let spList = param.modelC.split("-");
                        param.modelCStrat = spList[0];
                        param.modelCEnd = spList[1];
                    } else {
                        param.modelCType = 10;
                    }
                }
                param.ouid = localStorage.getItem("ouid");
                param.customerId = localStorage.getItem("customerId");
                param.limit = this.pageSize;
                param.pagePac = 1;
                param.pagePro = 1;
                service.selProductCurStock(param).then((res) => {
                    if (res.code == "200") {
                        if (res.data != null && res.data.length > 0) {
                            this.proCount = res.data[0].totalAmount
                            this.proWeight = parseFloat(res.data[0].totalWeight / 1000).toFixed(4)
                        } else {
                            this.proCount = 0
                            this.proWeight = 0
                        }
                    }
                })
                service.selPackageCurStock(param).then((res) => {
                    if (res.code == "200") {
                        if (res.data != null && res.data.length > 0) {
                            this.pacCount = res.count
                            this.pacWeight = parseFloat(res.data[0].totalWeight / 1000).toFixed(4)
                        } else {
                            this.pacCount = 0
                            this.pacWeight = 0
                        }
                    }
                });
            },
            selProductCurStock() {
                let param = this.searchValue;
                if (param.modelH != "") {
                    let index = param.modelH.indexOf("-");
                    if (index >= 0) {
                        param.modelHType = 20;
                        let spList = param.modelH.split("-");
                        param.modelHStrat = spList[0];
                        param.modelHEnd = spList[1];
                    } else {
                        param.modelHType = 10;
                    }
                }

                if (param.modelK != "") {
                    let index = param.modelK.indexOf("-");
                    if (index >= 0) {
                        param.modelKType = 20;
                        let spList = param.modelK.split("-");
                        param.modelKStrat = spList[0];
                        param.modelKEnd = spList[1];
                    } else {
                        param.modelKType = 10;
                    }
                }

                if (param.modelC != "") {
                    let index = param.modelC.indexOf("-");
                    if (index >= 0) {
                        param.modelCType = 20;
                        let spList = param.modelC.split("-");
                        param.modelCStrat = spList[0];
                        param.modelCEnd = spList[1];
                    } else {
                        param.modelCType = 10;
                    }
                }

                param.ouid = localStorage.getItem("ouid");
                param.customerId = localStorage.getItem("customerId");
                param.limit = this.pageSize;
                param.pagePro = this.pagePro;
                service.selProductCurStock(param).then((res) => {
                    if (res.code == "200") {
                        if (res.data != null && res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.listPro.push(res.data[i]);
                            }
                            this.pagePro++
                            // this.proCount = res.data[0].totalAmount
                            // this.proWeight = parseFloat(res.data[0].totalWeight / 1000).toFixed(4)
                        } else {
                            this.finishedPro = true;
                            // this.proCount = 0
                            // this.proWeight = 0
                        }
                        // 加载状态结束
                        this.loadingPro = false;
                        this.isLoadingPro = false;
                    } else {
                        this.loadingPro = false;
                        this.finishedPro = true;
                        this.isLoadingPro = false;
                        Toast(res.msg)
                    }
                });
            },
            selPackageCurStock() {
                let param = this.searchValue;
                if (param.modelH != "") {
                    let index = param.modelH.indexOf("-");
                    if (index >= 0) {
                        param.modelHType = 20;
                        let spList = param.modelH.split("-");
                        param.modelHStrat = spList[0];
                        param.modelHEnd = spList[1];
                    } else {
                        param.modelHType = 10;
                    }
                }

                if (param.modelK != "") {
                    let index = param.modelK.indexOf("-");
                    if (index >= 0) {
                        param.modelKType = 20;
                        let spList = param.modelK.split("-");
                        param.modelKStrat = spList[0];
                        param.modelKEnd = spList[1];
                    } else {
                        param.modelKType = 10;
                    }
                }

                if (param.modelC != "") {
                    let index = param.modelC.indexOf("-");
                    if (index >= 0) {
                        param.modelCType = 20;
                        let spList = param.modelC.split("-");
                        param.modelCStrat = spList[0];
                        param.modelCEnd = spList[1];
                    } else {
                        param.modelCType = 10;
                    }
                }

                param.ouid = localStorage.getItem("ouid");
                param.customerId = localStorage.getItem("customerId");
                param.limit = this.pageSize;
                param.pagePac = this.pagePac;
                service.selPackageCurStock(param).then((res) => {
                    if (res.code == "200") {
                        if (res.data != null && res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.listPac.push(res.data[i]);
                            }
                            this.pagePac++
                            // this.pacCount = res.count
                            // this.pacWeight = parseFloat(res.data[0].totalWeight / 1000).toFixed(4)
                        } else {
                            this.finishedPac = true;
                            // this.pacCount = 0
                            // this.pacWeight = 0
                        }
                        // 加载状态结束
                        this.loadingPac = false;
                        this.isLoadingPac = false;
                    } else {
                        this.loadingPac = false;
                        this.finishedPac = true;
                        this.isLoadingPac = false;
                        Toast(res.msg)
                    }
                });
            },
            searchPop() {
                this.show = true;
                // this.showtitle = false;
                // this.title = "筛选";
                // this.searchValue= {keywords:"", from:"", to:"", status:"0"};
                this.searchShowPop = true;
            },
            onRefresh() {
                this.onLoad();
            },
            //日期组件
            formatDate(date) {
                return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            },
            calendarConfirm(date) {
                const [start, end] = date;
                this.calendarShow = false;
                this.searchValue.from = `${this.formatDate(start)} - ${this.formatDate(end)}`;
                this.searchValue.startDate = this.$moment(start).format("YYYY-MM-DD");
                this.searchValue.endDate = this.$moment(end).format("YYYY-MM-DD");
            },
            resetSearch() {
                this.searchValue = {
                    modelHType: 10,
                    modelKType: 10,
                    modelCType: 10,
                    modelH: "",
                    modelC: "",
                    modelK: "",
                };
                this.selCargoProcessName = "";
                this.selCargoMaterialName = "";
                this.cargoOriginName = "";
                this.surfaceName = "";
                this.selWcode = ""
                this.selFreeze = ""
                this.selPcmode = ""
            },
        }
    }
</script>

<style scoped>
    .van-popup {
        background-color: #f7f8fa;
    }

    .hejcss {
        position: fixed;
        bottom: 50px;
        left: 0;
        z-index: 999;
        box-sizing: border-box;
        width: 100%;
        padding: 8px;
        background-color: #f7f8fa;
        font-size: 15px;
    }

    .searchwarp {
        margin-top: 46px;
    }

    .editwarp {
        width: 100%;
        margin: 56px auto;
    }

    .editwarp .swipewarp {
        margin-bottom: 10px;
    }

    .contentwarp {
        margin-top: 46px;
        height: calc(100vh - 50px);
    }

    .detailHeader {
        background-color: #1989fa;
        height: 70px;
        text-align: center;
        padding-top: 20px;
        margin-bottom: 20px;
        color: white;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    .detailLabel {
        color: #727272;
    }

    .detailLabel.detailtitle {
        color: #323233;
        font-weight: bold;
    }

    /deep/ .van-nav-bar .van-icon,
    /deep/ .van-nav-bar__text,
    /deep/ .van-calendar__day--middle,
    .van-icon.van-icon-arrow {
        color: #6685a4;
    }

    /deep/ .van-button--info,
    /deep/ .van-button--danger {
        /*background-color: #6685a4 ;*/
        /*border: 1px solid #6685a4 ;*/
        background-color: white;
        border: 1px solid white;
        color: #6685a4;
    }

    /deep/ .van-button--warning {
        background-color: #6685a4;
        border: 1px solid #6685a4;
    }

    /deep/ .ewm .van-button--info {
        border: 1px solid #6685a4;
        width: 200px
    }


    .searchwarp[data-v-1405fac1] {
        margin-top: 56px;
    }

    /deep/ .van-calendar__day--start,
    /deep/ .van-calendar__day--end,
    /deep/ .detailHeader[data-v-1405fac1] {
        background-color: #6685a4;
    }

    /deep/ .van-calendar__day--middle {
        background-color: #e4ebf3;
    }

    /*.van-cell::after{
        border-bottom: none;
    }*/
    .van-icon.van-icon-arrow {
        vertical-align: middle;
        margin-left: 5px;
    }

    .van-grid {
        padding: 10px;
    }

    /deep/ .van-image__img {
        border: #e4ebf3 1px solid;
    }

    .closebutton {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0px;
        height: 50px;
        width: 100% !important;
        /*font-size: 12px;*/
        z-index: 9999;
    }

    .van-button--default {
        border: 1px solid #e2e2e2;
    }

    .van-divider {
        margin: 0px !important;
    }


    /deep/ .thmx > .van-row {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    /deep/ .van-cell__value.van-cell__value--alone > .thmx:last-child > .van-row {
        padding-top: 10px;
        padding-bottom: 0;
    }

     .van-row{
         padding-left:16px;
         padding-right:16px;
     }
    .button {
        font-size: 16px;
        color: #ffffff;
        background: #6685a4;
        height: 32px;
    }
    .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .ellipsisRight {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: right;
    }
</style>